import Vue from 'vue'
import Glide from '@glidejs/glide'
Vue.prototype.$eventHub = new Vue();

const accordionMenu = {
    name: 'accordionMenu',
    props: {
        headerHeight: {
            type: Number,
            default:0
        },
        windowWidth: {
            type: Number,
            default:''
        },
        open: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            hover: false,
            innerOpen: this.open,
        };
    },
    methods: {
        toggleSubMenu() {
            this.innerOpen = !this.innerOpen;
        },
        onMouseOver(){
            if(this.windowWidth < 1024) {
                return
            }
            this.innerOpen = true
        },
        onMouseLeave(){
            if(this.windowWidth < 1024) {
                return
            }
            this.innerOpen = false
        },
        startTransition(el) {
            el.style.height = el.scrollHeight + "px";
        },
        endTransition(el) {
            el.style.height = "";
        },
    },
    watch: {
        open(value) {
            this.innerOpen = value;
        },
    },
}
const burgerButton = {
    name: 'burgerButton',
    inheritAttrs: false,
    props:['containCoverImage','scrollPosition' ],
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen
            document.body.classList.toggle("overflow-hidden");
            this.$emit('input', this.isOpen);
        }
    }
}

if (document.getElementById('vue-header')) {
    new Vue({
        delimiters: ["[[", "]]"],
        el: '#vue-header',
        components: {
            burgerButton,
            accordionMenu
        },
        data() {
            return {
                isOpen : false,
                isMenuOpen: false,
                windowWidth: window.innerWidth,
                scrollPosition:0,
                headerHeight: 0
            }
        },
        mounted() {
            this.setHeight()

            window.addEventListener("scroll", this.setScroll)
            window.addEventListener('resize', (e) => {
                this.setHeight()
                this.windowWidth = window.innerWidth;
            });
        },
        destroy() {
            window.removeEventListenr('scroll', this.setScroll)
        },
        watch : {
            scrollPosition: {
                handler: 'setScroll',
                immediate: true
            },   
        },
        methods: {
            setScroll() {
                this.scrollPosition = window.scrollY;
            },
            setHeight() {
                this.headerHeight = this.$el.clientHeight;
                if(document.getElementById('anchors-bar')) {
                    document.getElementById('anchors-bar').style.top = this.headerHeight + 'px';
                    let anchorsBarHeight = document.getElementById('anchors-bar').clientHeight;
                    const sectionScroll = [...document.querySelectorAll('[data-scroll]')];
                    sectionScroll.forEach(element => {
                        element.style.scrollMarginTop = (anchorsBarHeight + this.headerHeight + 8) + 'px'
                        element.style.scrollPaddingTop = (anchorsBarHeight + this.headerHeight + 8) + 'px'
                    } )

                }
                if(document.getElementById('main-menu') && this.windowWidth < 1024) {
                    document.getElementById('main-menu').style.top = this.headerHeight + 'px';
                    document.getElementById('main-menu').style.height = (window.innerHeight - this.headerHeight) + 'px';
                }

               

            }
        }
    })
}
